module.exports = __webpack_public_path__ + "static/media/html-block.9a68ad0d.png";